import {LISTA_DE_NOTICIAS, MAXIMO_DE_PAGINAS, PAGINA_ATUAL, DETALHE_DO_POST} from '../logicas/Noticias/NoticiasApi'

export function noticiasReducer(state={},action){
  switch (action.type){
    case LISTA_DE_NOTICIAS:
      if(action.payload){
        let actualList = state.list || [];
        let newList = actualList.concat(action.payload);
        return {...state, list: newList};
      } else {
        return {...state, list: undefined};
      }
    case MAXIMO_DE_PAGINAS:
      return {...state, maxPage:action.payload};
    case PAGINA_ATUAL:
      return {...state, actualPage:action.payload};
    case DETALHE_DO_POST:
      return {...state, postDetail:action.payload};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/noticiasReducer.js